import { gql } from 'urql';

export const CREATE_DOC_SITE_INTEGRATION = gql`
  mutation createDocSiteIntegration($input: CreateDocSiteIntegrationInput!) {
    createDocSiteIntegration(input: $input) {
      docSiteIntegration {
        active
        connected
        id
      }
      reason
    }
  }
`;

export const DELETE_DOC_SITE_INTEGRATION = gql`
  mutation deleteDocSiteIntegration($id: String!) {
    deleteDocSiteIntegration(id: $id) {
      message
      success
    }
  }
`;

export const UPDATE_DOC_SITE_INTEGRATION = gql`
  mutation updateDocSiteIntegration($input: UpdateDocSiteIntegrationInput!) {
    updateDocSiteIntegration(input: $input) {
      docSiteIntegration {
        active
        apiKey
        connected
        domain
        id
        name
      }
      reason
    }
  }
`;

export const GET_DOC_SITE_INTEGRATIONS = gql`
  query docSiteIntegrations {
    docSiteIntegrations {
      active
      apiKey
      connected
      domain
      id
      name
    }
  }
`;

export const GET_DOC_SITE_INTEGRATION = gql`
  query docSiteIntegration($id: ID!) {
    docSiteIntegration(id: $id) {
      active
      apiKey
      connected
      domain
      id
      name
      email
    }
  }
`;
